import React from "react"
import samplesData from "../refdata/samples.json"
import SampleCard from "../components/mmp-sample-card"
import PageMeta from "../components/page-meta"

export default function SamplesPage() {
    return <>
        <PageMeta
            title="Sample Gallery"
            description="Browse My Mini Prints' gallery of baby hand and foot casting examples – 3D castings, impressions, and framed keepsakes in Essex."
            canonical="/samples"
            image="https://www.myminiprints.co.uk/images/Samples/3D1-2HF-XX.webp"
        />

        <div className="container">

        <br />
            <div className="card shadow">
                <h1 className="card-header display-4" style={{"backgroundColor": "#DCE774", "color": "#504E51"}}>Samples</h1>
            </div>
        <br />

        <div className="card mx-auto p-1 shadow" style={{"width" : "100%"}}>
            <div className="card-body">
                <p className="card-text">
                    Here is a selection of my previous work for you to view.
                    <br />
                    <br />
                    Please note that these are examples of what I can do, but I have many other options for colour combinations and layouts - do not feel that you are restricted by these examples as I am happy to work with you to design exactly the keepsake that you want.
                </p>
            </div>
            
        </div>
        <br />
            
            <div className="row">
                {samplesData.Samples.map((sample) => (
                <React.Fragment key={sample.imageFile}>
                    <div className="col-sm-6 col-md-4 col-lg-3">
                        <SampleCard title={sample.title} image={samplesData.imgPath + sample.imageFile}></SampleCard>
                    </div>
                </React.Fragment>
                ))}

            </div>
            <br />
        </div>


        <br />
        <br />

    </>
}